import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/logo.webp'
import _imports_1 from '@/assets/imgs/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0c49041d")

_pushScopeId("data-v-0c49041d")
const _hoisted_1 = _imports_0
const _hoisted_2 = { class: "m-login-root" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("picture", { class: "logo" }, [
  /*#__PURE__*/_createVNode("source", {
    type: "image/webp",
    srcset: _hoisted_1
  }),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    "data-was-processed": "true",
    "data-src": "~@/assets/imgs/logo.png"
  })
], -1)
const _hoisted_5 = { class: "field input-container" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "icon icon-user" }, null, -1)
const _hoisted_7 = { class: "field input-container" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "icon icon-lock" }, null, -1)
const _hoisted_9 = { class: "field input-container code" }
const _hoisted_10 = { class: "error" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "footer" }, "环球360 娱乐场版权所有", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_language_box = _resolveComponent("language-box")

  return (_openBlock(), _createBlock("div", _hoisted_2, [
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createVNode("input", {
          placeholder: _ctx.iN('login.usernameplaceholder'),
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.uname = $event))
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.uname]
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createVNode("input", {
          placeholder: _ctx.iN('login.passwordplaceholder'),
          type: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pwd = $event))
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.pwd]
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _withDirectives(_createVNode("input", {
          type: "number",
          maxlength: 4,
          placeholder: _ctx.iN('login.code'),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cpth = $event)),
          onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkCapchaLenght && _ctx.checkCapchaLenght(...args)))
        }, null, 40, ["placeholder"]), [
          [
            _vModelText,
            _ctx.cpth,
            void 0,
            { number: true }
          ]
        ]),
        _createVNode("img", { src: _ctx.imgSrc }, null, 8, ["src"]),
        _createVNode("div", {
          class: "icon icon-reload",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getImageSrc && _ctx.getImageSrc(...args)))
        })
      ]),
      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1),
      _createVNode("div", {
        class: "field button-fill",
        onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"]))
      }, [
        _createVNode("span", null, _toDisplayString(_ctx.iN('login.login')), 1)
      ])
    ]),
    _hoisted_11,
    _createVNode("div", {
      class: ["lang", _ctx.lang],
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showLangbox = true))
    }, _toDisplayString(_ctx.iN(`lang.${_ctx.lang}`)), 3),
    _createVNode("div", {
      class: "cs-service icon-costumer-service",
      title: "线上客服",
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.OnCLickedServer && _ctx.OnCLickedServer(...args)))
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showLangbox)
          ? (_openBlock(), _createBlock(_component_language_box, {
              key: 0,
              class: "lang-box",
              onOnClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showLangbox = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})